import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { deleteKeys } from "../../app/slices/TrainingLocalizationSlice";
import { deleteTake } from "../../app/slices/TrainingSlice";
import { removeWarningsAndErrorsForInteractions } from "../../app/slices/ValidationSlice";
import { getKeysFromInteraction } from "../../helpers/KeysHelper";
import Take3D from "../../models/Take3D";

export function useDeleteTake3D() {
  const dispatch = useDispatch();

  const deleteTake3D = useCallback(
    (take: Take3D) => {
      let keysToDelete: string[] = [];
      const interactionIds: string[] = [];

      (take.interactions ?? []).forEach((interaction) => {
        keysToDelete = keysToDelete.concat(
          getKeysFromInteraction(interaction, "key_")
        );
        interactionIds.push(interaction.id);
      });

      if (take.transition) {
        keysToDelete = keysToDelete.concat(
          getKeysFromInteraction(take.transition, "key_")
        );
        interactionIds.push(take.transition.id);
      }

      if (take.sequence) {
        // traverses the sequence nodes too, releasing keys of nested interactions
        keysToDelete = keysToDelete.concat(
          getKeysFromInteraction(take.sequence, "key_")
        );
        interactionIds.push(take.sequence.id);
        (take.sequence.nodes ?? []).forEach((node) => {
          const nodeInteraction = node.data?.interaction;
          if (nodeInteraction) interactionIds.push(nodeInteraction.id);
        });
      }

      dispatch(deleteTake(take.id));
      dispatch(deleteKeys(keysToDelete));
      dispatch(removeWarningsAndErrorsForInteractions({ interactionIds }));
    },
    [dispatch]
  );

  return { deleteTake3D } as const;
}
